import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Campaign Concepts", desc: "Narrative-first creative concepts designed around clear business outcomes." },
  { title: "Visual Production", desc: "Static and motion assets delivered in channel-ready formats at scale." },
  { title: "Brand Story Systems", desc: "Coherent storytelling frameworks across website, social, and outbound channels." },
  { title: "Creative Testing", desc: "Structured variation testing to identify designs that outperform baseline results." },
  { title: "Launch Support", desc: "Cross-platform rollout planning with sequencing, copy, and asset operations." },
  { title: "Continuous Refinement", desc: "Ongoing design improvements based on performance data and audience behavior." },
];

const CreativeServices = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Creative systems that"
    titleAccent="perform."
    subtitle="Modern creative direction paired with production discipline to support fast-moving growth teams."
    features={features}
    ctaLabel="DISCUSS CREATIVE PARTNER"
  />
);

export default CreativeServices;